import type { ListStatuses } from "~/types/api";
import { StatusItem } from "./status-item";

type Props = {
  status: ListStatuses;
  isSelected: boolean;
  count: number;
};

const MAX_STACK = 5;
const PEEK_PX = 4;
const SCALE_STEP = 0.03;

export const StatusItemPreview = ({ status, isSelected, count }: Props) => {
  const extraLayers = Math.min(count, MAX_STACK) - 1;

  return (
    <div className="relative cursor-grabbing">
      {Array.from({ length: extraLayers }, (_, i) => {
        const depth = extraLayers - i;
        return (
          <div
            key={depth}
            aria-hidden
            className="absolute inset-0 origin-bottom rounded border border-blue-300 bg-blue-100 shadow-sm"
            style={{
              transform: `translateY(${depth * PEEK_PX}px) scale(${1 - depth * SCALE_STEP})`,
            }}
          />
        );
      })}
      <StatusItem
        status={status}
        isSelected={isSelected}
        tabIndex={-1}
        className="relative bg-white shadow-lg"
      />
      {count > 1 && (
        <span className="bg-gxe-primary absolute -top-2 -right-2 flex h-5 min-w-5 items-center justify-center rounded-full px-1.5 text-xs font-semibold text-white">
          {count}
        </span>
      )}
    </div>
  );
};
